import { PreviewButton } from '@/components/Preview/PreviewButton'
import ContentSections from '@/components/Sections/ContentSections'
import PageSEO from '@/components/SEO/PageSEO'
import StructuredData from '@/components/SEO/StructuredData'
import { getSanityClient } from '@/services/sanityClient'
import { getPageByHandle } from '@/utils/getPages'
import { getRecentArticlesHandles } from '@/utils/getRecentArticleHandles'
import { BRAND_NAME } from '@/utils/constants'

export default function BrandBlog({ page, preview, previewToken }) {
  // Get blog URL for structured data
  const blogUrl = `${process.env.NEXT_PUBLIC_DOMAIN}/blogs/stories`

  // Create blog schema
  const blogSchema = {
    '@context': 'https://schema.org',
    '@type': 'Blog',
    headline: page.fields?.seo?.metaTitle || 'Stories Blog',
    description: page.fields?.seo?.metaDesc || '',
    url: blogUrl,
    image: page.fields?.hero?.desktopBackgroundImage?.asset?.url,
    datePublished: page.createdAt || new Date().toISOString(),
    dateModified: page.updatedAt || new Date().toISOString(),
    author: {
      '@type': 'Organization',
      name: BRAND_NAME,
      url: process.env.NEXT_PUBLIC_DOMAIN
    }
  }

  return (
    <div className="stories-blog">
      {preview && previewToken && <PreviewButton />}
      <StructuredData type="blog" data={page} />
      <PageSEO
        seo={page.fields.seo}
        images={page.fields?.hero?.desktopBackgroundImage ? [{
          url: page.fields.hero.desktopBackgroundImage.asset.url,
          alt: page.fields.hero.header || ''
        }] : []}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(blogSchema) }}
      />
      <ContentSections sections={page.fields.content} />
    </div>
  )
}

export async function getStaticProps({ draftMode }) {
  const preview = draftMode || false;
  const previewToken = preview ? process.env.SANITY_READ_TOKEN : ``;
  if (preview && !previewToken) {
    throw new Error(`Preview mode is active, but SANITY_READ_TOKEN is not set in environment variables`);
  }

  const page = await getPageByHandle('stories-blog', getSanityClient(previewToken))

  if (page?.fields?.content?.some(content => content._type === 'featuredBlogContent')) {
    await getRecentArticlesHandles(page.fields.content)
  }

  return {
    props: {
      page,
      preview,
      previewToken
    }
  }
}
